import { markInvoiceAsSent, markProjectAsSentToQuickbooks } from "@/api/invoices";
import { RouteButton, OrangeButton } from "@/components/Buttons";
import { InvoiceProps } from "@/interfaces/invoices_types";

export function InvoiceRow({ data }: { data: InvoiceProps; }) {
    const handleMarkAsSent = async () => {
        if (data.invoice_id && confirm("Are you sure you want to mark this invoice as sent?")) {
            const response = await markInvoiceAsSent(data.invoice_id);
            if (response.operation === "COMPLETED") {
                alert("Invoice marked as sent");
                window.location.reload();
            } else {
                alert("Error marking invoice as sent");
            }
        }
    };

    const handleMarkSentToQuickbooks = async () => {
        if (data.project && confirm("Are you sure you want to mark this invoice as sent to Quickbooks?")) {
            const response = await markProjectAsSentToQuickbooks(data.project);
            if (response.operation === "COMPLETED") {

                alert("Project marked as sent to Quickbooks");
                window.location.reload();

            } else {
                alert("Error marking project as sent to Quickbooks");
            }
        }
    };
    return (
        <div className="bg-gray-100">
            <div className="flex flex-row gap-2 ml-4">
                <RouteButton route={`/invoices/update_invoice/${data.invoice_id}`} text="Edit Invoice" />
                <OrangeButton onClick={handleMarkAsSent}>Mark as Sent</OrangeButton>
                <OrangeButton onClick={handleMarkSentToQuickbooks} tooltip="This will set the 'Sent to Quickbooks' field in the project to Yes.">Sent to Quickbooks</OrangeButton>
            </div>
        </div>
    );
}
